import { CountryCode } from "libphonenumber-js";
import * as React from "react";
import * as phone_number from "../phone_number";

export interface PhoneInputState {}

export interface PhoneInputProps {
  className: string;
  textClassName: string;
  placeholderClassName: string;
  defaultCountry: CountryCode;
  value: string;
  placeholder: string;
  rootRef: (e: HTMLElement | null) => void;
  onChange: (value: string) => void;
}

export class PhoneInput extends React.Component<PhoneInputProps, PhoneInputState> {
  constructor(props: PhoneInputProps) {
    super(props);

    this.state = {};
  }

  private input: HTMLInputElement | null = null;

  componentDidMount() {
    if (this.input === null) {
      throw new Error("Component is unmounted");
    }
    const input = this.input;

    input.addEventListener("focus", () => {
      console.log("FOCUS");
      const len = input.value.length * 2;
      input.setSelectionRange(len, len);
      setTimeout(() => (input.value = input.value), 0); // eslint-disable-line no-self-assign
      input.style.color = "";
    });
    input.addEventListener("blur", () => {
      input.style.color = "transparent";
      console.log("BLUR");
    });
    input.addEventListener("input", () => {
      const cleaned = cleanPhoneNumber(input.value);
      input.value = cleaned;
      this.props.onChange(cleaned);
    });
    input.addEventListener("touchstart", (e) => {
      e.preventDefault();
      setTimeout(() => (input.value = input.value), 0); // eslint-disable-line no-self-assign
    });
    input.addEventListener("touchend", (e) => {
      e.preventDefault();
      setTimeout(() => (input.value = input.value), 0); // eslint-disable-line no-self-assign
    });
    input.addEventListener("touchcancel", (e) => {
      e.preventDefault();
      setTimeout(() => (input.value = input.value), 0); // eslint-disable-line no-self-assign
    });
    input.addEventListener("click", (e) => {
      e.preventDefault();
      input.focus();
      setTimeout(() => (input.value = input.value), 0); // eslint-disable-line no-self-assign
    });

    input.focus();
  }

  focusInput(): void {
    if (this.input === null) {
      throw new Error("Component is unmounted");
    }

    this.input.focus();
  }

  render() {
    const placeholder: boolean = this.props.value.length === 0;

    return (
      <div
        style={{
          display: "flex",
        }}
      >
        <div
          className={this.props.className + " " + this.props.textClassName}
          style={{
            display: "inline-block",
            position: "relative",
            width: "auto",
          }}
        >
          +1
        </div>
        <div ref={(e) => this.props.rootRef(e)} className={this.props.className}>
          <div
            className={
              this.props.textClassName + (placeholder ? " " + this.props.placeholderClassName : "")
            }
            style={{
              textAlign: "left",
            }}
          >
            <span
              className="PhoneEntryScreen__phoneInputSpan"
              style={
                placeholder
                  ? {
                      textIndent: "2px",
                      float: "left",
                      overflow: "visible",
                    }
                  : {
                      paddingRight: "2px",
                    }
              }
            >
              {placeholder ? (
                this.props.placeholder
              ) : (
                <>
                  {phone_number.asYouType(this.props.defaultCountry, this.props.value)}
                  <div className="PhoneEntryScreen__phoneInputCaret" />
                </>
              )}
            </span>
            <input
              ref={(e) => (this.input = e)}
              className={this.props.textClassName + " PhoneEntryScreen__phoneInputTextInput"}
              type="tel"
              maxLength={10}
              style={{
                background: "transparent !important",
                margin: "0",
                padding: "0",
                letterSpacing: "99px",
                overflow: "hidden",
                border: "0",
                zIndex: 1,
              }}
            />
          </div>
          <div
            onClick={() => this.focusInput()}
            style={{
              position: "absolute",
              display: "inline-block",
              left: "0",
              top: "0",
              background: "",
              width: "100%",
              height: "100%",
              paddingRight: "10px",
              letterSpacing: "10px",
              zIndex: 2,
            }}
          />
        </div>
      </div>
    );
  }
}

function cleanPhoneNumber(str: string): string {
  const filtered = str.replace(/[^0-9+]/g, "");
  if (filtered.length <= 1) {
    return filtered;
  }
  return filtered.charAt(0) + filtered.substr(1).replace(/\+/g, "");
}
